$(document).ready(function(){

    var currentSlideIndex = 0;
    var totalSlides = $( ".count-me" ).length;
    var speed = 200;

    setCurrentSlideNumber(11,20);


    function setCurrentSlideNumber(number,total) {
        $('#currentSlideIndex').html(number);
        $('#totalSlides').html(total);
    }


    function swipePrev() {
         // Swipe the vertical sider into position
         projectslider_vertical.slidePrev();

        // Swipe the main slider into position
        projectslider_main.slideNext();

        // Swipe the main slider into position
        projectslider_aside.slideNext();
    }
    function swipeNext() {
         // Swipe the vertical sider into position
         projectslider_vertical.slideNext();

        // Swipe the main slider into position
        projectslider_main.slidePrev();

        // Swipe the main slider into position
        projectslider_aside.slidePrev();
    }

    function swipeProject(direction) {

        if(direction=="prev") {
            console.log('prev');
            swipePrev();
        } else if (direction=="next") {
            console.log('next');
            swipeNext();
        }

    }

    var projectslider_aside = new Swiper('.projectslider__aside', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        loop: true,
        shortSwipes:false,
        longSwipes:false,
        loopAdditionalSlides: 100,
        speed:speed,

        preloadImages:false,
        lazyLoading:true,
        lazyLoadingInPrevNext:true,

    });

    var projectslider_vertical = new Swiper('.projectslider__vertical', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        direction: 'vertical',
        //effect:'slide',
        loop: true,
        shortSwipes:false,
        longSwipes:false,
        loopAdditionalSlides: 100,

        preloadImages:false,
        lazyLoading:true,
        lazyLoadingInPrevNext:true,

        //autoplay:100,
        onInit: function(swiper){
            var i = swiper.realIndex+1;
            setCurrentSlideNumber('0'+i,'0'+totalSlides);

        }

    });



    var projectslider_main = new Swiper('.projectslider__main', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        spaceBetween: 30,
        loop: true,
        shortSwipes:false,
        longSwipes:false,
        loopAdditionalSlides: 100,
        //autoplay:100

    });

   // onInit(swiper)



    $('body').on('click','#projectslider__previous:not(.disabled)',function(e){
        e.preventDefault();
        var clickedItem = $(this);
        clickedItem.addClass('disabled');
        setTimeout(function() {
            clickedItem.removeClass('disabled');
        }, 400);


        swipeProject('prev');
        var i = projectslider_vertical.realIndex+1;
        setCurrentSlideNumber('0'+i,'0'+totalSlides);

    });

    $('body').on('click','#projectslider__next:not(.disabled)',function(e){
        e.preventDefault();
        var clickedItem = $(this);
        clickedItem.addClass('disabled');
        setTimeout(function() {
            clickedItem.removeClass('disabled');
        }, speed+50);


        swipeProject('next');
        var i = projectslider_vertical.realIndex+1;
        setCurrentSlideNumber('0'+i,'0'+totalSlides);
    });






    // -----------------------------------------------------------------
    // Slider Controller
    // -----------------------------------------------------------------


//  var projectSlider = new Swiper ('.projects__slider', {
//     // Optional parameters
//     effect:"fade",
//     //direction: 'vertical',
//     speed:500
//   }).on('slideChangeStart', function () {
//      console.log('slide change start');
//     });



//     // $('.slide-3').click(function(e) {

//     // $(".menu .active").removeClass('active');
//     // $(this).addClass('active');
//     // mySwiper.slideTo( $(slideToShow).index(),1000,false );

// // });

// var timer;

// $('body').on('click','.project__link',function(e){
//     e.preventDefault();
//     //
//     goToByScroll('projects',3000);

//     slideToShow = $(this).attr('href');
//     myIndex = $(slideToShow).index();
//     console.log(myIndex);
//     projectSlider.slideTo( myIndex,1000 );

//     clearTimeout(timer);

//     timer = setTimeout(function() {
//         projectSlider.slideTo( $('#first').index(),100 );
//     }, 10000);

//   });




});
